var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 160,
    viewBox: "0 0 430 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4682_65046)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4682_65046",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -23,
    y: -54,
    width: 464,
    height: 213
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.361 145.528C230.666 148.376 244.368 133.764 285.769 136.763C327.17 139.762 332.335 155.741 367.971 158.323C403.607 160.904 415.829 152.811 430 139L440.99 -20.6057L-10.7529 -53.3318L-22.3101 106.201C-22.3101 106.201 -8.8309 131.026 27.3295 133.645C63.4899 136.265 65.6625 120.818 108.112 123.893C150.561 126.968 152.057 142.681 191.361 145.528Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4682_65046)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4682_65046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.392 46.5L-10.3028 13.8499L-34.4847 281.529L416.21 314.179L440.392 46.5Z",
    fill: "url(#paint0_linear_4682_65046)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4682_65046",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 432,
    height: 123
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205 122.828C242.5 122.828 254.5 107.264 294 107.264C333.5 107.264 339.5 122.828 373.5 122.828C407.5 122.828 418 113.842 430.5 99.0424V0H-0.499969V99.0424C-0.499969 99.0424 14 122.828 48.5 122.828C83 122.828 84 107.264 124.5 107.264C165 107.264 167.5 122.828 205 122.828Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4682_65046)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_4682_65046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430 0H0V169.5H430V0Z",
    fill: "url(#paint1_linear_4682_65046)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4682_65046",
    x: -92.4846,
    y: -44.1504,
    width: 590.877,
    height: 416.329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 29
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4682_65046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4682_65046",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_4682_65046",
    x: -58,
    y: -58,
    width: 546,
    height: 285.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 29
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4682_65046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4682_65046",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4682_65046",
    x1: 192.5,
    y1: 61.5,
    x2: 178,
    y2: 168.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC1B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF241B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4682_65046",
    x1: 215,
    y1: 0,
    x2: 215,
    y2: 169.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA1211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D13924"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4682_65046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ae25bd77dcada3ca7b9b4192b29347b7.svg";
export { ForwardRef as ReactComponent };